import { Trans } from '@lingui/react/macro';

import type { AudienceType } from '@/api/audience';
import { Button } from '@/components/buttons';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/Dialog';
import useInstanceNavigate from '@/hooks/useInstanceNavigate';
import { ROUTES } from '@/router';

type Props = {
  audience?: AudienceType;
  onOk: () => void;
  onCancel: () => void;
};

const AudienceDeleteConfirmDialog = ({ audience, onOk, onCancel }: Props) => {
  const navigate = useInstanceNavigate();

  const handleOk = () => {
    if (audience?.isTAM) {
      navigate(ROUTES.companySettings.path);
    } else {
      onOk();
    }
  };

  return (
    <Dialog open={audience != null} onOpenChange={(isOpen) => !isOpen && onCancel()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            <Trans>Delete Audience</Trans>
          </DialogTitle>
        </DialogHeader>
        <div>
          {audience?.isTAM ? (
            <Trans>
              This audience is set as your TAM Audience. If you want to delete it, please reassign
              TAM in Company Settings before attempting to delete here.
            </Trans>
          ) : (
            <Trans>Are you sure you want to delete this Audience?</Trans>
          )}
        </div>
        <DialogFooter>
          <DialogClose
            render={
              <Button size="large">
                <Trans>Cancel</Trans>
              </Button>
            }
          />
          {audience?.isTAM ? (
            <Button size="large" variant="on-primary" onClick={handleOk}>
              <Trans>Take me there</Trans>
            </Button>
          ) : (
            <Button size="large" variant="primary" danger onClick={handleOk}>
              <Trans>Yes, Delete</Trans>
            </Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AudienceDeleteConfirmDialog;
